export default __webpack_public_path__ + "static/media/main.bd1f589d.jpg";